import { clearLocalStorageIfVersionChanged } from '@app/local-storage-hash';

export function AppInitializer(): void {
  return clearLocalStorageIfVersionChanged();
}
